export default "__VITE_ASSET__B3Cf4_nY__"